export const searchFormOption = function () {
  return [
    // {
    //   prop: 'keyword',
    //   label: '关键字',
    //   type: 'input',
    //   placeholder: '请输入名称',
    //   width: '20%'
    // },
  ]
}


export default {}